export const Features = {
  FinancialModelling: false,
  BaseCampLayout: true,
};
